// This file contains just the const variable used through out the project
// Refered https://www.iban.com/country-codes for 3 and 2 letter country codes.

// const flipped = Object.entries(teamNameAcronymn).map(([key, value])=>[value, key]);

export const teamNameAcronymn = {
    'Argentina': 'ARG',
    'Australia': 'AUS',
    'Austria': 'AUT',
    'Belgium': 'BEL',
    'Brazil': 'BRA',
    'Cameroon': 'CMR',
    'Canada': 'CAN',
    'Colombia': 'COL',
    'Costa Rica': 'CRC',
    'Croatia': 'CRO',
    'Czech Republic': 'CZE',
    'Denmark': 'DEN',
    'Egypt': 'EGY',
    'England': 'ENG',
    'Ecuador': 'ECU',
    'France': 'FRA',
    'Finland': 'FIN',
    'Ghana': 'GHA',
    'Germany': 'GER',
    'Hungary': 'HUN',
    'Iceland': 'ISL',
    'Iran': 'IRN',
    'Italy': 'ITA',
    'Japan': 'JPN',
    'Korea Republic': 'KOR',
    'South Korea': 'KOR',
    'Mexico': 'MEX',
    'Morocco': 'MAR',
    'Nigeria': 'NGA',
    'Netherlands': 'NED',
    'North Macedonia': 'MKD',
    'Panama': 'PAN',
    'Peru': 'PER',
    'Poland': 'POL',
    'Portugal': 'POR',
    'Qatar': 'QAT',
    'Russia': 'RUS',
    'Saudi Arabia': 'KSA',
    'Scotland': 'SCO',
    'Senegal': 'SEN',
    'Serbia': 'SRB',
    'Spain': 'ESP',
    'Sweden': 'SWE',
    'Slovakia': 'SVK',
    'Switzerland': 'SUI',
    'Tunisia': 'TUN',
    'Turkey': 'TUR',
    'Uruguay': 'URU',
    'Ukraine': 'UKR',
    'Wales': 'WAL',
    'United States': 'USA',
    'TBD': 'TBD',
  }
  
  //Look at the folder /img/country-flags-main/* 
  //for the SVG name
export var team2LetterAcronym = {
    'Argentina': 'ar',
    'Australia': 'au',
    'Austria': 'at',
    'Belgium': 'be',
    'Brazil': 'br',
    'Cameroon': 'cr',
    'Canada': 'ca',
    'Colombia': 'co',
    'Costa Rica': 'cr',
    'Croatia': 'hr',
    'Czech Republic': 'cz',
    'Denmark': 'dk',
    'Ecuador': 'ec',
    'Egypt': 'eg',
    'England': 'gb',
    'France': 'fr',
    'Finland': 'fi',
    'Ghana': 'gh',
    'Germany': 'de',
    'Hungary': 'hu',
    'Iceland': 'is',
    'Iran': 'ir',
    'Italy': 'it',
    'Japan': 'jp',
    'Korea Republic': 'kp',
    'South Korea': 'kr',
    'Mexico': 'mx',
    'Morocco': 'ma',
    'Nigeria': 'ng',
    'Netherlands': 'nl',
    'North Macedonia': 'mk',
    'Panama': 'pa',
    'Peru': 'pe',
    'Poland': 'pl',
    'Portugal': 'pt',
    'Qatar': 'qa',
    'Russia': 'ru',
    'Saudi Arabia': 'sa',
    'Scotland': 'gb-sct',
    'Senegal': 'sn',
    'Serbia': 'rs',
    'Spain': 'es',
    'Sweden': 'se',
    'Slovakia': 'sk',
    'Switzerland': 'ch',
    'Tunisia': 'tn',
    'Turkey': 'tr',
    'Uruguay': 'uy',
    'Ukraine': 'ua',
    'Wales': 'gb-wls',
    'United States': 'us',
  }

  export const team3To2LetterAcronym = {
    'ARG':'ar',
    'AUS':'au',
    'AUT':'at',
    'BEL':'be',
    'BRA':'br',
    'CMR':'cr',
    'CAN':'ca',
    'COL':'co',
    'CRC':'cr',
    'CRO':'hr',
    'CZE':'cz',
    'DEN':'dk',
    'EGY':'ec',
    'ENG':'eg',
    'ECU':'gb',
    'FRA':'fr',
    'FIN':'fi',
    'GHA':'gh',
    'GER':'de',
    'HUN':'hu',
    'ISL':'is',
    'IRN':'ir',
    'ITA':'it',
    'JPN':'jp',
    'KOR':'kp',
    'KOR':'kr',
    'MEX':'mx',
    'MAR':'ma',
    'NGA':'ng',
    'NED':'nl',
    'MKD':'mk',
    'PAN':'pa',
    'PER':'pe',
    'POL':'pl',
    'POR':'pt',
    'QAT':'qa',
    'RUS':'ru',
    'KSA':'sa',
    'SCO':'gb-sct',
    'SEN':'sn',
    'SRB':'rs',
    'ESP':'es',
    'SWE':'se',
    'SVK':'sk',
    'SUI':'ch',
    'TUN':'tn',
    'TUR':'tr',
    'URU':'uy',
    'UKR':'ua',
    'WAL':'gb-wls',
    'USA':'us',
    'TBD':'TBD',
  }